import About from '../sections/About'
import Advise from '../sections/Advise'
import Build from '../sections/Build'
import Close from '../sections/Close'
import FieldNotes from '../sections/FieldNotes'
import Hero from '../sections/Hero'
import Hire from '../sections/Hire'
import Lanes from '../sections/Lanes'

export default function HomePage() {
  return (
    <main className="page">
      <Hero />
      <Lanes />
      <Advise />
      <Build />
      <Hire />
      <FieldNotes />
      <About />
      <Close />
    </main>
  )
}
